export default __webpack_public_path__ + "static/media/exclusive.4e0e9ec2.svg";